var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import WorkHeader from "~/components/workspace/work-header.vue";
import WorkMenu from "~/components/workspace/work-menu.vue";
import WorkReminder from "~/components/workspace/work-reminder.vue";
var workspaceModule = namespace("workspace");
var WorkSpaceLayout = /** @class */ (function (_super) {
    __extends(WorkSpaceLayout, _super);
    function WorkSpaceLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WorkSpaceLayout.prototype.mounted = function () {
        var _this = this;
        if (this.unReadCount) {
            this.$reminder.notify(function (options) {
                return _this.$createElement(WorkReminder, options);
            });
        }
        // 收到消息通知时更新未读消息
        this.$reminder.addMessageListener().subscribe(function (data) {
            // 通知消息
            _this.$reminder.notify(function (options) {
                return _this.$createElement(WorkReminder, options);
            });
        });
    };
    __decorate([
        workspaceModule.State
    ], WorkSpaceLayout.prototype, "currentPage", void 0);
    __decorate([
        workspaceModule.State
    ], WorkSpaceLayout.prototype, "currentTabs", void 0);
    __decorate([
        workspaceModule.State
    ], WorkSpaceLayout.prototype, "unReadCount", void 0);
    WorkSpaceLayout = __decorate([
        Component({
            components: {
                WorkHeader: WorkHeader,
                WorkMenu: WorkMenu,
                WorkReminder: WorkReminder
            }
        })
    ], WorkSpaceLayout);
    return WorkSpaceLayout;
}(Vue));
export default WorkSpaceLayout;
